module.exports = __webpack_public_path__ + "static/13invgde-9db6260783e9ce36bbc031b060a4f781.gif";